import React from "react";
import { Link } from "@tanstack/react-router";
import { Card, CardContent } from "./card";
import { Button, type ButtonProps } from "./button";
import { safeBuilderText } from "~/lib/builder-utils";

interface CTASectionProps {
  title?: unknown;
  description?: unknown;
  link?: unknown;
  linkText?: unknown;
  track?: ButtonProps["track"];
  children?: React.ReactNode;
}

export const CTASection = ({
  title,
  description,
  link,
  linkText,
  track,
  children,
}: CTASectionProps) => {
  const safeTitle = safeBuilderText(title);
  const safeDescription = safeBuilderText(description);
  const safeLink = safeBuilderText(link);
  const safeLinkText = safeBuilderText(linkText);

  return (
    <Card className="shadow-purple-700/8 border-purple-300/50 bg-gradient-to-br from-purple-100 via-violet-100 to-purple-200 p-0">
      <CardContent className="mx-auto w-full p-8 py-12 text-center">
        <div className="mx-auto max-w-md">
          {safeTitle && (
            <h2 className="font-heading text-text-primary text-2xl font-medium tracking-tight">
              {safeTitle}
            </h2>
          )}
          {safeDescription && (
            <p className="text-text-secondary mt-2 leading-normal">
              {safeDescription}
            </p>
          )}
        </div>
        {children}
        {safeLink && safeLinkText && (
          <Link to={safeLink} className="mt-6 block w-full text-center">
            <Button variant="fancy" size="lg" track={track}>
              {safeLinkText}
            </Button>
          </Link>
        )}
      </CardContent>
    </Card>
  );
};
